import MobileSearchSection from './MobileSearchSection';

export default MobileSearchSection;
